// extracted by mini-css-extract-plugin
export default {"heading":"NegativePromptInput_heading__cqc8K"};